export default "__VITE_ASSET__BIkK$2IJ__"